// extracted by mini-css-extract-plugin
export default {"wrapper":"MusicNew_wrapper__Ap6AU","headerPLayList":"MusicNew_headerPLayList__iXX7Q","lists":"MusicNew_lists__zYUGi"};